import { Component, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { SubcategoryModel } from '../../models/subcategories/subcategory.model';
import { AddOrEditSubcategoryComponent } from './add-or-edit-subcategory/add-or-edit-subcategory.component';
import { DeleteSubcategoryComponent } from './delete-subcategory/delete-subcategory.component';
import { TranslateService } from "@ngx-translate/core";
import { Subject, takeUntil } from "rxjs";
import { MenuService } from "../../services/menus/menu.service";
import { AuthenticationService } from "../../../share-modul/services/authentication/authentication.service";

@Component({
  selector: 'app-subcategories',
  templateUrl: './subcategories.component.html',
  styleUrls: ['./subcategories.component.scss']
})
export class SubcategoriesComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public listAllSubcategories: Array<SubcategoryModel> = new Array<SubcategoryModel>();
  public imagePath: string = './assets/images/logo/category.png'
  public spinner: boolean = false;
  public items: { [name: string]: MenuItem[] } = {};
  public companyId: string;

  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService,
    private messageService: MessageService,
    public translate: TranslateService,
    private menuService: MenuService,
    private authService: AuthenticationService
  ) {
    this.translate.stream('HEADER.APP_LANGUAGE').subscribe( () => {
      this.addFunctionToAllSubcategories();
    });
  }

  ngOnInit(): void {
    this.companyId = this.authService.getCompanyId();
    this.loadSubcategoriesForCompany();
  }

  //#endregion
  //#region Public Methods
  createSubcategory() {
    const ref = this.dialogService.open(AddOrEditSubcategoryComponent, {
      data: {
        companyId: this.companyId
      },
      header: this.translate.instant('SUBCATEGORY.ADD_SUBCATEGORY'),
      styleClass: 'dialog_subcategory , ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.loadSubcategoriesForCompany();
        this.messageService.add({severity:'success', summary: this.translate.instant("SUBCATEGORY.SUBCATEGORY_ADDED"), life: 3000});
      }
    });
  }

  editSubcategory(subcategory: SubcategoryModel) {
    const ref = this.dialogService.open(AddOrEditSubcategoryComponent, {
      data: {
        subcategory: subcategory,
        companyId: this.companyId
      },
      header: this.translate.instant('SUBCATEGORY.EDIT_SUBCATEGORY'),
      styleClass: 'dialog_subcategory ,ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.loadSubcategoriesForCompany();
        this.messageService.add({severity:'success', summary: this.translate.instant("SUBCATEGORY.SUBCATEGORY_EDITED"), life: 3000});
      }
    });
  }

  deleteSubcategory(id: string) {
    const ref = this.dialogService.open(DeleteSubcategoryComponent, {
      data: {
        id: id
      },
      header: this.translate.instant('SUBCATEGORY.DELETE_SUBCATEGORY'),
      width: '685px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.loadSubcategoriesForCompany();
        this.messageService.add({severity:'success', summary: this.translate.instant("SUBCATEGORY.SUBCATEGORY_DELETED"), life: 3000});
      }
    });
  }

  addFunctionToAllSubcategories() {
    this.listAllSubcategories.forEach(subcategory => {
      this.items[subcategory.id] = [{
        label: this.translate.instant('EDIT'),
        command: () => {
          this.editSubcategory(subcategory);
        }
      },
        {
          label: this.translate.instant('DELETE'),
          command: () => {
            this.deleteSubcategory(subcategory.id);
          }
        }];
    });
  }

  private loadSubcategoriesForCompany() {
    this.listAllSubcategories = new Array<SubcategoryModel>();
    this.spinner = true;
    this.menuService.listSubcategoryForCompany(this.companyId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.listAllSubcategories = response;
          this.addFunctionToAllSubcategories();
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  determineImageUrl(pictureUrl: string) {
    const image = pictureUrl ? pictureUrl : this.imagePath;
    return encodeURI(image);
  }
  //#endregion
}
